import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Analytics from "../AnalyticsService/AnalyticsService";

export const AnalyticsPageTracker: React.FC = () => {
  const { pathname } = useLocation();

  // Key on pathname, not the location object: react-router mints a new location for
  // every search-param write too, and callers such as SearchPage
  // rewrite them per keystroke — keying on the object emits duplicate pageviews.
  useEffect(() => {
    Analytics.page(pathname);
  }, [pathname]);

  return null;
};
